// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0a4ExgP5dff_Aa0AAXqZtpfR8NACrrQY",
  authDomain: "our-vibe-co.firebaseapp.com",
  projectId: "our-vibe-co",
  storageBucket: "our-vibe-co.firebasestorage.app",
  messagingSenderId: "7654945807",
  appId: "1:7654945807:web:e95645330310a21e499f7a",
  measurementId: "G-BC1RTQRC8R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);